import { UIWrappedElement, UIClassesSpec } from './types';
import { $el } from './elements';
import { uiTrackAttach } from './attach';
import { UIAnimationName } from './animate';

export type UIViewSpec = UIView | HTMLElement;
export type UIViewRemoveSpec = UIWrappedElement | Element;
export type UIViewAddItem = UIWrappedElement | Element | Node | string;
export type UIViewAddSpec = UIViewAddItem | (false | undefined | UIViewAddSpec)[];
export type UIMultiViewSpec = UIViewSpec | UIViewSpec[];

export interface UIViewAddParams {
    prepend?: boolean;
    before?: UIViewSpec;
    after?: UIViewSpec;
    replace?: UIViewSpec;
}

export type UIViewTag = 'div' | 'button' | 'aside' | 'nav' | 'header' | 'article' | 'tr' | 'td' | 'th' | 'thead' | 'tbody' | 'table' | 'footer' | 'section' | 'form' | 'span' | 'label';

export class UIView {
    readonly ui_elem: HTMLElement;
    ui_visible_proxy?: UIViewSpec;
    protected readonly root: HTMLElement;

    constructor(root: HTMLElement)
    constructor(tag?: UIViewTag, classes?: UIClassesSpec, content?: UIViewAddSpec)
    constructor(root_or_tag: UIViewTag | HTMLElement = 'div', classes?: UIClassesSpec, content?: UIViewAddSpec) {
        this.ui_elem = this.root = (typeof root_or_tag === 'string') ? $el.create(root_or_tag, classes, content) : root_or_tag;
    }

    ui_add(what: UIViewAddSpec) {
        this.root.ui_add(what);
    }

    ui_prepend(what: UIViewAddSpec) {
        this.root.ui_prepend(what);
    }

    ui_insert(content: UIViewAddSpec, ref: UIViewSpec | Node | null | undefined, after?: boolean) {
        this.root.ui_insert(content, ref, after);
    }

    ui_replace(content: UIViewAddSpec) {
        this.root.ui_replace(content);
    }

    addHelperView(what: UIViewSpec) {
        what.ui_elem.ui_is_helper = true;
        this.root.ui_add(what);
    }

    remove(): void {
        uiTrackAttach();
        this.root.remove();
    }

    ui_empty(new_content?: UIViewAddSpec) {
        this.root.ui_empty(new_content);
    }

    ui_render(new_content: UIViewAddItem[]) {
        this.root.ui_render(new_content);
    }

    get classList() {
        return this.root.classList;
    }

    get style() {
        return this.root.style;
    }

    ui_show(animation?: UIAnimationName, show?: boolean) {
        if(this.ui_visible_proxy)
            this.ui_visible_proxy.ui_show(animation, show);
        else
            this.root.ui_show(animation, show);
    }

    ui_hide(animation?: UIAnimationName) {
        if(this.ui_visible_proxy)
            this.ui_visible_proxy.ui_hide(animation);
        else
            this.root.ui_hide(animation);
    }

    get isConnected() {
        return this.root.isConnected;
    }

    protected reconstruct(root: HTMLElement) {
        const old = this.ui_elem;
        (this as any).ui_elem = root;
        old.ui_replace(root);
    }
}
